// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CartIcon_cartLink__1RpDk {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  text-decoration: none;
  transition: background-color 150ms ease-out;
  overflow: visible;
}

.CartIcon_cartLink__1RpDk:hover {
  background: #f3f4f6;
}

.CartIcon_cartLink__1RpDk:hover .CartIcon_cartIcon__AfG\\+e {
  color: #111827;
}

.CartIcon_cartLink__1RpDk:focus-visible {
  outline: 2px solid rgba(124, 58, 237, 0.4);
  outline-offset: 2px;
}

.CartIcon_cartIcon__AfG\\+e {
  width: 22px;
  height: 22px;
  color: #374151;
  transition: color 150ms ease-out;
}

.CartIcon_badge__Y9LSG {
  position: absolute;
  top: -4px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #ef4444;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  z-index: 501;
  border: 2px solid white;
}
`, "",{"version":3,"sources":["webpack://./src/components/cart/CartIcon.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":[".cartLink {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  text-decoration: none;\n  transition: background-color 150ms ease-out;\n  overflow: visible;\n}\n\n.cartLink:hover {\n  background: #f3f4f6;\n}\n\n.cartLink:hover .cartIcon {\n  color: #111827;\n}\n\n.cartLink:focus-visible {\n  outline: 2px solid rgba(124, 58, 237, 0.4);\n  outline-offset: 2px;\n}\n\n.cartIcon {\n  width: 22px;\n  height: 22px;\n  color: #374151;\n  transition: color 150ms ease-out;\n}\n\n.badge {\n  position: absolute;\n  top: -4px;\n  right: -6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  background: #ef4444;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 700;\n  z-index: 501;\n  border: 2px solid white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cartLink": `CartIcon_cartLink__1RpDk`,
	"cartIcon": `CartIcon_cartIcon__AfG+e`,
	"badge": `CartIcon_badge__Y9LSG`
};
export default ___CSS_LOADER_EXPORT___;
